import AxiosUtil from '../utils/axiosUtil';
import { BaseService } from './BaseService';

export const BaseCheckPriceService = (function () {
  let instance;
  const BASE_URI = '/apis/check-prices/base-tables';
  const baseService = BaseService.getInstance(BASE_URI, 'baseCheckPrice');

  function init() {
    return {
      // ...BaseService,
      ...baseService,
      list: async function (params) {
        const queryString = Object.entries(params)
          .map((e) => e.join('='))
          .join('&');
        return await AxiosUtil.Async.get(BASE_URI, queryString);
      },
      checkStartDate: async function (enterpriseId = 0) {
        return await AxiosUtil.Async.get(
          BASE_URI + '/checker/start-date',
          `eid=${enterpriseId}`
        );
      },
      register: async function (data) {
        return await AxiosUtil.Async.post(BASE_URI, data);
      },
      getData: async function (priceTableId = 0) {
        return await AxiosUtil.Async.get(BASE_URI + `/${priceTableId}`);
      },
      delete: async function (priceTableId = 0) {
        return await AxiosUtil.Async.delete(BASE_URI + `/${priceTableId}`);
      },
    };
  }

  return {
    getInstance: function () {
      if (!instance) instance = init();
      return instance;
    },
  };
})();
